module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/teckentolkat_100x56-4a88297a789bed34bb4fde13086a2e79.png";